import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageBanner from "@/components/PageBanner";
import { Link } from "react-router-dom";
import { UserPlus, GraduationCap, Share2, Headphones, TrendingUp, ShoppingBag, ArrowRight } from "lucide-react";

/**
 * How to Get Associated — dedicated onboarding page.
 * Contains ONLY the registration process (6 steps) and a Register CTA. No
 * plan, no products, no rewards details.
 */

const STEPS = [
  { n: "01", icon: ShoppingBag,    l: "Buy and Experience", d: "Explore eligible Samara Wiz products. Understand their features, use and value before recommending them." },
  { n: "02", icon: UserPlus,       l: "Register",            d: "Complete the official associate registration, accept company policies and activate your account under the current plan." },
  { n: "03", icon: GraduationCap,  l: "Learn",               d: "Attend product, sales and business training. Understand Sales Points, referrals, matching and payouts." },
  { n: "04", icon: Share2,         l: "Share and Refer",     d: "Share products responsibly with customers and refer interested individuals — without exaggerated income or product claims." },
  { n: "05", icon: Headphones,     l: "Serve",               d: "Follow up with customers, help them select products, resolve queries via authorised support channels." },
  { n: "06", icon: TrendingUp,     l: "Earn and Grow",       d: "Eligible earnings and rewards are calculated per the official compensation plan, qualification rules and company policies." },
];

export default function GetAssociated() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <PageBanner
        label="How to Get Associated"
        title="Six clear steps to begin your journey."
        subtitle="Register, learn and grow with Samara Wiz — the structured path to becoming an authorised associate."
        crumbs={[{ label: "Home", to: "/" }, { label: "Smart Opportunity", to: "/opportunity" }, { label: "How to Get Associated" }]}
      />

      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {STEPS.map((s) => (
            <div
              key={s.n}
              data-testid={`get-step-${s.n}`}
              className="p-6 bg-white border border-line rounded-sm hover:border-gold/50 hover:shadow-md transition-all relative"
            >
              <div className="flex items-start justify-between">
                <div className="w-11 h-11 grid place-items-center bg-royal text-gold rounded-sm">
                  <s.icon size={20} />
                </div>
                <div className="font-serif text-3xl text-gold-deep/80">{s.n}</div>
              </div>
              <div className="font-serif text-xl text-royal mt-4">{s.l}</div>
              <p className="text-sm text-navy/65 mt-2 leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <Link
            to="/register"
            data-testid="get-associated-cta"
            className="inline-flex items-center gap-2 bg-gold text-royal px-6 py-3 rounded-sm hover:bg-gold-deep hover:text-white transition-colors font-medium"
          >
            Register as an Associate <ArrowRight size={16} />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
